export function getRoomUrl(token, noMyColor, unlimited) {
  return `/rooms/${token}/${noMyColor}${unlimited ? '/unlimited' : ''}`;
}

export function getIaRoomUrl(token, noMyColor, unlimited) {
  return `/rooms/ia/${noMyColor}${unlimited ? '/unlimited' : ''}`;
}
